import { safetyTips } from "@/mocks/home";

export default function Safety() {
  return (
    <section id="safety" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-semibold tracking-widest text-primary-600 uppercase">
            Safety &amp; Compliance
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            安全与合规提示
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            网盘与下载渠道的信息环境比较复杂。下面六条提示来自常见的使用场景，做好它们能显著降低误点、误装与隐私泄露的风险。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {safetyTips.map((tip) => (
            <article key={tip.title} className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <span className="w-11 h-11 rounded-full bg-secondary-100 text-secondary-800 flex items-center justify-center">
                <i className={`${tip.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base md:text-lg font-bold text-foreground-950">{tip.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-start gap-4 rounded-lg border border-primary-300 bg-primary-50 p-5 md:p-6">
          <span className="w-12 h-12 shrink-0 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
            <i className="ri-scales-3-line text-2xl"></i>
          </span>
          <div>
            <h3 className="font-heading text-base md:text-lg font-bold text-primary-900">免责声明</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              本页为内容检索与渠道科普信息页，仅整理公开可讨论的查询思路与注意事项，
              <strong className="font-semibold text-foreground-900">不存储、不托管、也不提供任何受版权保护的影片文件或直接下载地址</strong>。
              请通过正规、合法的渠道获取与观看作品，并遵守所在国家或地区的法律法规以及各平台用户协议。
              对于用户因使用第三方渠道而产生的任何后果，本站不承担责任。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}